import { Component, Input } from '@angular/core';
import { Vehicle2 } from 'src/main/webapp/assets/models/iter.model';

/**
 * Componente per mostrare i dettagli di un veicolo (es. cambio automatico, porte)
 */
@Component({
  selector: 'app-vehicle-details',
  styleUrls: ['./vehicle-details.component.scss'],
  templateUrl: './vehicle-details.component.html'
})
export class VehicleDetailsComponent {

  @Input() public vehicle!: Vehicle2;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public vehicleHasDoors(): boolean {
    return +this.vehicle.services?.doors > 0;
  }

  public vehicleHasPassengers(): boolean {
    return +this.vehicle.services?.passengerQuantity > 0;
  }

  public vehicleHasBaggages(): boolean {
    return this.vehicle.services?.baggageQuantityMax > 0;
  }

  public vehicleGearBox(): string {
    if (this.vehicle.services?.transmission) {
      return this.vehicle.services?.transmission;
    }
    else {
      return 'Manuale';
    }
  }

}
